import React from "react"; // 🔥 Added React import for JSX

export const A4_WIDTH_PX = 794;
export const A4_HEIGHT_PX = 1123;

export const renderTextWithLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);

    return parts.map((part, index) => {
        if (part.match(urlRegex)) {
            return (
                <a key={index} href={part} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline hover:text-blue-800 pointer-events-auto">
                    {part}
                </a>
            );
        }
        return part;
    });
};

export const shouldShowSignature = (pageIndex, totalPages, mode = 'last_page', pagePoint = 0) => {
    const pageNum = pageIndex + 1;
    switch (mode) {
        case 'all_pages': return true;
        case 'first_page': return pageIndex === 0;
        case 'first_last': return pageIndex === 0 || pageIndex === totalPages - 1;
        case 'first_two': return pageIndex === 0 || pageIndex === 1;
        case 'specific': return pageNum === Number(pagePoint);
        case 'last_page': default: return pageIndex === totalPages - 1;
    }
};